// Combined scripting for player guide pages
// Quick Start, Quests, Cross-Platform
const tocRoot = document.querySelector(".TableOfContents");
if (tocRoot) {
    const tocLinks = document.querySelectorAll("a.TableOfContents-link");
    const tocDropdown = document.querySelector('.TableOfContents-dropdown');
    const tocDropdownOptions = tocDropdown.querySelectorAll('.TableOfContents-dropdown option');
    const tocSections = [];
    const tocSectionsByName = {};
    tocLinks.forEach((link) => {
        const id = link.getAttribute('data-link');
        const targetSection = document.getElementById(id);
        const node = {
            id,
            link,
            elem: targetSection
        };
        tocSections.push(node);
        tocSectionsByName[id] = node;
    });

    function syncTableOfContents() {
        const midpoint = document.querySelector('#toc-sticky .Sticky-content').getBoundingClientRect().top;
        for (const section of tocSections) {
            const rect = section.elem.getBoundingClientRect();
            const isInView = rect.top < midpoint && rect.bottom > midpoint;
            section.link.classList.toggle('is-active', isInView);

            if (isInView) {
                tocDropdown.value = section.id;
            }
        }
    }

    window.addEventListener('scroll', syncTableOfContents);
    syncTableOfContents();

    function syncTableOfContentsDropdown(event) {
        window.location.href = '#' + event.target.value;
    }

    tocDropdown.addEventListener('change', syncTableOfContentsDropdown);

    const PlatformSelector = document.querySelector('.PlatformSelector');
    if (PlatformSelector) {
        const PlatformTabs = PlatformSelector.querySelectorAll('.PlatformSelector-option');
        const GuideContentRoot = document.querySelector('#quickstart-guide .SectionContent--guide');

        function syncLinksAndContents(platform) {
            PlatformTabs.forEach((t) => {
                t.classList.toggle('is-selected', t.getAttribute("data-platform-option") === platform);
            });
            tocRoot.setAttribute("data-selected-platform", platform);
            GuideContentRoot.setAttribute("data-selected-platform", platform);
            tocDropdownOptions.forEach((option) => {
                if (option.hasAttribute("data-platform")) {
                    option.hidden = option.getAttribute("data-platform") === platform;
                }
            });
        }

        PlatformTabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                const platform = tab.getAttribute("data-platform-option");
                syncLinksAndContents(platform);
            });
        });

        function initShowcase(showcase) {
            const images = showcase.querySelectorAll('.ItemShowcase-image');
            const content = showcase.querySelectorAll('.ItemShowcase-content');
            images.forEach((image) => {
                const index = image.getAttribute('data-index');
                image.addEventListener('click', (e) => {
                    images.forEach((image) => {
                        image.classList.toggle('is-selected', image.getAttribute('data-index') === index);
                    });
                    content.forEach((c) => {
                        c.classList.toggle('is-selected', c.getAttribute('data-index') === index);
                    });
                });
            });
        }

        const ItemShowcases = GuideContentRoot.querySelectorAll(".ItemShowcase");
        ItemShowcases.forEach(initShowcase);
    }
}
